var _path, _path2, _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgWardBed = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.8868 12.0001C7.69938 12.0001 7.51573 11.9474 7.35679 11.8481L2.189 8.61813C2.06549 8.54093 1.92277 8.5 1.77712 8.5V8.5C1.34793 8.5 1 8.84793 1 9.27712V14.3001C1 14.8524 1.44772 15.3001 2 15.3001L6.5 15.3001L7.6 15.3001L21.0107 15.3001C21.563 15.3001 22.0107 14.8524 22.0107 14.3001V13.0001C22.0107 12.4478 21.563 12.0001 21.0107 12.0001H7.8868Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 9C7 7.89543 7.89543 7 9 7H18C19.1046 7 20 7.89543 20 9V9C20 10.1046 19.1046 11 18 11H9C7.89543 11 7 10.1046 7 9V9Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 7,
  r: 2
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 13,
  width: 2,
  height: 7,
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 13,
  width: 2,
  height: 7,
  rx: 1
})));
export default SvgWardBed;